// Recovered compiled webpack factory 1150. Edit this function expression; run npm run build.
(e, t, r) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return d;
      },
    }));
  let a = r(95155),
    n = r(12115),
    l = r(24437);
  function s(e) {
    return { default: e && "default" in e ? e.default : e };
  }
  r(36552);
  let i = { loader: () => Promise.resolve(s(() => null)), loading: null, ssr: !0 },
    d = function (e) {
      let t = { ...i, ...e },
        r = (0, n.lazy)(() => t.loader().then(s)),
        d = t.loading;
      function o(e) {
        let s = d ? (0, a.jsx)(d, { isLoading: !0, pastDelay: !0, error: null }) : null,
          i = !t.ssr || !!t.loading,
          o = i ? n.Suspense : n.Fragment,
          c = t.ssr
            ? (0, a.jsxs)(a.Fragment, { children: [null, (0, a.jsx)(r, { ...e })] })
            : (0, a.jsx)(l.BailoutToCSR, {
                reason: "next/dynamic",
                children: (0, a.jsx)(r, { ...e }),
              });
        return (0, a.jsx)(o, { ...(i ? { fallback: s } : {}), children: c });
      }
      return ((o.displayName = "LoadableComponent"), o);
    };
}
